import { Navigate } from '@sorare/routing';

import { FOOTBALL_SCOUTING_CENTER_STATS } from '@sorare/core/src/constants/__generated__/routes';

export const ScoutingCenterPage = () => {
  return <Navigate to={FOOTBALL_SCOUTING_CENTER_STATS} />;
};

export default ScoutingCenterPage;
